module.exports = "/_next/static/images/calendar-line-3e01ef8d8a77a4bc225cb2a4814923b6.svg";